import { SelectField, SelectOption } from 'components/atoms/Select';
import { CarPreferencesSelectControlMui5 } from '../components';
import {
  SetFiltersValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { SearchFilters } from 'shared/types/api/getAuctions';

export const ModelFilter = ({
  models,
  setFiltersValue,
  disabled = false,
}: {
  models: SearchFilters['models'];
  setFiltersValue: SetFiltersValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  return (
    <CarPreferencesSelectControlMui5 fullWidth>
      <SelectField
        variant='outlined'
        displayEmpty
        onChange={(e) => {
          if (disabled) {
            return;
          }
          const modelName = e.target.value as string;
          const makeName =
            models.filter((model) => model.modelName == modelName)[0]
              ?.makeName || undefined;
          setFiltersValue({
            ...filters,
            make: makeName,
            model: modelName,
          });
        }}
        value={filters.model || ''}
        label='Model'
      >
        <SelectOption value={''}>All Models</SelectOption>
        {models.map((model, id) => (
          <SelectOption key={id} value={model.modelName}>
            {model.modelName}
          </SelectOption>
        ))}

        {filters.model && !models.length ? (
          <SelectOption value={filters.model}>{filters.model}</SelectOption>
        ) : null}
      </SelectField>
    </CarPreferencesSelectControlMui5>
  );
};
